import { ReweighError } from '@shared/classes/error/reweigh-error';

export class XpoApiError extends ReweighError {}
